import { render, staticRenderFns } from "./PlaceOrderModal.vue?vue&type=template&id=fd47b830&scoped=true&"
import script from "./PlaceOrderModal.vue?vue&type=script&lang=js&"
export * from "./PlaceOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./PlaceOrderModal.vue?vue&type=style&index=0&id=fd47b830&lang=scss&scoped=true&"
import style1 from "./PlaceOrderModal.vue?vue&type=style&index=1&lang=css&"
import style2 from "./PlaceOrderModal.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd47b830",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCheckbox,VChip,VCol,VDialog,VIcon,VRow,VSimpleTable,VSpacer,VToolbar,VToolbarTitle,VTooltip})
